export default {
  dbl_sql_table: '物理表',
  dbl_sql_add_select: '简易模式',
  dbl_sql_add_sql: 'SQL模式',
  dbl_sql_add_edit_sql: 'SQL 编辑',
  dbl_sql_add_database: '数据库',
  // Schema 的中文还是Schema
  dbl_sql_add_schema: 'Schema',
  dbl_sql_add_dataset: '数据表',
  dbl_sql_add_search_dataset: '搜索数据表或字段',
  dbl_sql_add_search_schema: '搜索Schema', 
  dbl_sql_add_search_database: '搜索数据库', 
  dbl_sql_add_run: '运行',
  dbl_sql_add_preview: '全表预览',  
  dbl_sql_add_format: '格式化样式',
  dbl_sql_add_grammar_detection: '语法检测',
  dbl_sql_add_clear: '清空', 
  dbl_sql_add_result: '结果',
  dbl_sql_add_success_msg: '成功提示',
  dbl_sql_add_failed_msg: '失败提示',
  dbl_sql_edit_placeholder: '请在此处输入 SQL查询。例如，"SELECT * FROM table_name"'
};